import { makeStyles } from '@material-ui/core/styles';

const useStyles = (theme) => ({
  centered: {
    display: 'flex'
  }
});

export default makeStyles(useStyles);
